import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import InvoiceCceForm from '@/components/Fiscal/Invoice/InvoiceForms/InvoiceCceForm';
import { DefaultRouteTabs, SaveButton } from '@/components/_common';
import { InvoiceSituation } from '@/core/domain/invoice/invoices/invoices.enums';
import { PageProps } from '@/types/PageProps';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import invoiceValidateRoutes from '../../Invoice.validateRoutes';

const InvoiceCcePage: React.FC<PageProps> = ({ route }) => {
  const intl = useIntl().formatMessage;
  const {
    invoiceId,
    disabled,
    isLoading,
    handleSubmit,
    invoice: { data: invoice, isLoading: invoiceIsLoading },
  } = useInvoiceFormContext();

  const disabledFields =
    invoice?.situation !== InvoiceSituation.IN_TYPING &&
    invoice?.situation !== InvoiceSituation.VALIDATED;

  const { pathname } = useLocation();
  const URL = '/' + pathname.split('/').slice(1, -1).join('/');

  return (
    <DefaultRouteTabs
      baseKey={invoiceId}
      basePath={URL}
      route={invoiceValidateRoutes(route, invoice?.situation)}
      permissions={route.permissions}
      resourceNotFound={!invoice && !invoiceIsLoading}
      extra={
        <SaveButton
          disabled={disabled || disabledFields}
          onClick={handleSubmit}
          loading={isLoading}
        >
          {intl({ id: 'invoice.createadditionalData.btn.save' })}
        </SaveButton>
      }
    >
      <Helmet title={useIntl().formatMessage({ id: route.name })} />
      <InvoiceCceForm />
    </DefaultRouteTabs>
  );
};

export default InvoiceCcePage;
